import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.542 8.333A4.992 4.992 0 0 0 5.833 5c-2.758 0-5 2.242-5 5s2.242 5 5 5a4.992 4.992 0 0 0 4.709-3.333h3.625V15H17.5v-3.333h1.667V8.333h-8.625Zm-4.709 3.334c-.916 0-1.666-.75-1.666-1.667s.75-1.667 1.666-1.667c.917 0 1.667.75 1.667 1.667s-.75 1.667-1.667 1.667Z",
    fill: "#757575"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };